import { addDays } from 'date-fns/addDays';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { BulkClosedForDepartureValidation } from 'uplisting-frontend/validations';

export default class BulkClosedForDepartureRepositoryService extends BaseRepositoryService<
  ModelRegistry['bulk-closed-for-departure']
> {
  recordName = 'bulk-closed-for-departure';
  implementMethods = ['buildChangeset', 'createRecord'];

  validation = BulkClosedForDepartureValidation;

  get defaultParams() {
    return {
      from: new Date(),
      to: addDays(new Date(), 1),
    };
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/bulk-closed-for-departure': BulkClosedForDepartureRepositoryService;
  }
}
